export default "<template>\n\n  <KTextbox\n    label=\"Input with maximum 20 characters\"\n    :maxlength=\"20\"\n  />\n\n</template>\n";